import Input, { InputProps } from "@/shared/form/input";

export function DynamicAttributeFieldSimpleString(props: InputProps) {
  return <Input allowClear {...props} />;
}
